// import { useState } from 'react';
import {
  Box,
  Container,
  // FormControl,
  Grid,
  // InputLabel,
  // MenuItem,
  // Select,
} from '@mui/material';
import Page from '../../components/Page';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { findDashboardReport } from '../../store/dashboardReport/api';
import { useAppDispatch, useAppSelector } from '../../store';
import { OverviewTotalCustomers } from './app/overview-customers';
import { SuperUserRole } from '../../enum';
// import { useAppDispatch } from '../../store';
// import { findDashboardReport } from '../../store/dashboardReport/api';
// import { TIME_PERIOD } from '../../constants';
// import { TimePeriod } from '../../enum';
// import { OverviewTotalCustomers } from './app/overview-customers';
import { FaGift } from 'react-icons/fa';
import { VscGraphLine } from 'react-icons/vsc';
import { MdAttachMoney } from 'react-icons/md';
import { MdPendingActions } from 'react-icons/md';
import { MdContactMail } from 'react-icons/md';
import Loader from '../../components/Loader';
import { OverviewExpense } from './app/overview-expense';
import DashboardUserTable from './app/userTable';
import DashboardAdvertiseTable from './app/advertiseTable';
import DashboardLicenseRenewalTable from './app/licenseRenewalTable';
// import { OverviewSales } from './app/overview-sales';
// import { OverviewExpense } from './app/overview-expense';
// import Loader from '../../components/Loader';
// import DashboardOrderTable from './app/orderTable';

const Index = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  // const [timeDuration, setTimeDuration] = useState<string>(TimePeriod.today);
  const { name } = useAppSelector((state) => state.auth.user);
  const { data, isLoading } = useAppSelector((state) => state.dashboardReport);
  const userRole = useAppSelector((state) => state.auth.user.userRole);

  useEffect(() => {
    // if (status === 'idle') {
    dispatch(findDashboardReport({}));
    // }
  }, [dispatch]);

  return (
    <Page title='Dashboard'>
      <Container maxWidth='xl'>
        {isLoading ? (
          <div
            style={{
              height: '76vh',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Loader />
          </div>
        ) : (
          <>
            <Grid
              container
              spacing={2}
              sx={{ pt: 3 }}
            >
              <Grid
                item
                xs={12}
                sm={6}
              >
                <Box sx={{ pb: 1 }}>
                  <Typography variant='h4'>Hi, {name}. Welcome back</Typography>
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              spacing={2}
              sx={{ pt: 3 }}
            >
              {userRole !== 'adminTier3' && (
                <>
                  <Grid item xs={12} sm={4}>
                    <OverviewTotalCustomers
                      title={'Individual Users'}
                      sx={{ height: '100%' }}
                      value={data?.individualUsersCount}
                      icon={<MdAttachMoney />}
                      onClick={() => navigate(`/users?userRole=${SuperUserRole.individual}`)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <OverviewTotalCustomers
                      title={'Company Users'}
                      sx={{ height: '100%' }}
                      value={data?.companyUsersCount}
                      icon={<FaGift />}
                      onClick={() => navigate(`/users?userRole=${SuperUserRole.company}`)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <OverviewTotalCustomers
                      title={'Broker Users'}
                      sx={{ height: '100%' }}
                      value={data?.brokerUsersCount}
                      icon={<FaGift />}
                      onClick={() => navigate(`/users?userRole=${SuperUserRole.broker}`)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <OverviewTotalCustomers
                      title={'Agent Users'}
                      sx={{ height: '100%' }}
                      value={data?.agentUsersCount}
                      icon={<FaGift />}
                      onClick={() => navigate(`/users?userRole=${SuperUserRole.agent}`)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <OverviewTotalCustomers
                      title={'Admin Users'}
                      sx={{ height: '100%' }}
                      value={data?.adminUsersCount}
                      icon={<MdContactMail />}
                      onClick={() => navigate(`/users`)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <OverviewTotalCustomers
                      title={'Not Approved Company Users'}
                      sx={{ height: '100%' }}
                      value={data?.notApprovedCompanyUserCount}
                      icon={<VscGraphLine />}
                      onClick={() => navigate(`/users?userRole=${SuperUserRole.company}&isApproved=false`)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <OverviewTotalCustomers
                      title={'Not Approved Broker Users'}
                      sx={{ height: '100%' }}
                      value={data?.notApprovedBrokerUserCount}
                      icon={<VscGraphLine />}
                      onClick={() => navigate(`/users?userRole=${SuperUserRole.broker}&isApproved=false`)}
                    />
                  </Grid>
                </>
              )}

              <Grid
                item
                xs={12}
                sm={4}
              >
                <OverviewTotalCustomers
                  title={'Pending Ads Request Count'}
                  sx={{ height: '100%' }}
                  value={data?.submitAdvertiseCount ?? 0}
                  icon={<MdPendingActions />}
                  onClick={() => navigate('/advertise')}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={4}
              >
                <OverviewTotalCustomers
                  title={'Pending Contact Us Request Count'}
                  sx={{ height: '100%' }}
                  value={data?.pendingContactUsRequestCount ?? 0}
                  icon={<MdContactMail />}
                  onClick={() => navigate('/contact-form')}
                />
              </Grid>
            </Grid>

            <Grid
              container
              spacing={2}
              sx={{ pt: 3 }}
            >
              {/* <Grid
              item
              xs={12}
              sm={8}
            >
              {data?.totalSales && (
                <OverviewSales
                  // data={[
                  //   { date: '9/07/2024', value: 1 },
                  //   { date: '10/07/2024', value: 5 },
                  // ]}
                  data={data?.totalSales}
                  // sx={{ height: '100%' }}
                />
              )}
            </Grid> */}
              <Grid
                item
                xs={12}
                sm={8}
                md={8}
                lg={8}
              >
                {/* {data?.totalOrders && ( */}
                {/* <OverviewExpense
                  // data={[
                  //   { date: '9/07/2024', value: 1 },
                  //   { date: '10/07/2024', value: 5 },
                  // ]}
                  data={data?.totalOrders}
                  sx={{ height: '100%' }}
                /> */}
                <OverviewExpense
                  chartSeries={[
                    data?.publishedAdvertiseCount ?? 0,
                    data?.submitAdvertiseCount ?? 0,
                  ]}
                  labels={['Published Advertise', 'Submitted Advertise']}
                  sx={{ height: '100%' }}
                />
                {/* )} */}
              </Grid>

              {/* <Grid
              item
              xs={12}
              lg={12}
            >
              <DashboardOrderTable />
            </Grid> */}
            </Grid>

            <Grid
              container
              spacing={2}
              sx={{ pt: 3 }}
            >
              <Grid
                item
                xs={12}
                lg={12}
              >
                <DashboardAdvertiseTable />
              </Grid>
              {userRole !== 'adminTier3' && (
                <>
                <Grid
                  item
                  xs={12}
                  lg={12}
                >
                  <DashboardUserTable />
                </Grid>
                  <Grid
                    item
                    xs={12}
                    lg={12}
                  >
                    <DashboardLicenseRenewalTable />
                  </Grid>
                </>
              )}
            </Grid>
          </>
        )}
      </Container>
    </Page>
  );
};

export default Index;
